import * as Yup from "yup";
import { validation, conditionalValidation } from "../../../utils/constants";

export const FormikObj = {
    initialValues: {
    initialValues: {
        id: "",
        orgId: "",
        name: "",
        type: "",
        fileType: "PDF",
        protocol: "",
        hostName: "",
        userName: "",
        secret: "",
        target: "",
        messageSpec: "",
    },
    },
    validationSchema: Yup.object({
        orgId: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Organization",
                mandatory: true
            }),
        name: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Report Delivery Name",
                mandatory: true
            }),
        type: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Report Delivery Type",
                mandatory: true
            }),
        protocol: conditionalValidation(
            Yup.string().when('type', {
                is: "MFT",
                then: Yup.string().required("Protocol is Required"),
                otherwise: Yup.string().notRequired()
            }),
            {
                validation,
                label: "Protocol"
            }),
        hostName: conditionalValidation(
            Yup.string().when('type', {
                is: "MFT",
                then: Yup.string().required("Hostname is Required"),
                otherwise: Yup.string().notRequired()
            }),
            {
                validation,
                label: "Hostname"
            }),
        fileType: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Filetype",
                mandatory: true
            }),
        target: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Delivery Target",
                mandatory: true
            }),
        userName: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Username",
            }) 
    }),
}

export const FormikObjEdit = {
    initialValues: {
        id: "",
        orgId: "",
        name: "",
        type: "",
        fileType: "",
        protocol: "",
        hostName: "",
        userName: "",
        secret: "",
        target: "",
        messageSpec: "",
    },
    validationSchema: Yup.object({
        orgId: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Organization",
                mandatory: true
            }),
        name: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Report Delivery Name",
                mandatory: true
            }),
        type: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Report Delivery Type",
                mandatory: true
            }),
        protocol: conditionalValidation(
            Yup.string().when('type', {
                is: "MFT",
                then: Yup.string().required("Protocol is Required"),
                otherwise: Yup.string().notRequired()
            }),
            {
                validation,
                label: "Protocol"
            }),
        hostName: conditionalValidation(
            Yup.string().when('type', {
                is: "MFT",
                then: Yup.string().required("Hostname is Required"),
                otherwise: Yup.string().notRequired()
            }),
            {
                validation,
                label: "Hostname"
            }),
        fileType: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Filetype",
                mandatory: true
            }),
        target: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Delivery Target",
                mandatory: true
            }), 
        userName: conditionalValidation(
            Yup.string(),
            {
                validation,
                label: "Username",
            }) 
    }),
}
export const fileTypes = [
    { value: "PDF", label: "PDF" },
]
export const deliveryTypes = [
    { value: "FAX", label: "Fax" },
    { value: "MFT", label: "MFT" },
]
export const protocols = [
    { value: 'SFTP', label: "SFTP"},
    { value: 'HTTPS', label: 'HTTPS'}
]
